export default __webpack_public_path__ + "static/media/information-small.6da08337.svg";